/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

/* eslint no-return-assign: 0 */
import React from 'react';
import { Form, Input, Checkbox, Button } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { UserOutlined } from '@ant-design/icons';
import Password from '../../../components/password';
import CaptchaSlider from '../../../components/slider';
import { APP_URL } from '../../../utils/config';

const FormItem = Form.Item;
const formItemLayout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 0 },
};

type Props = {
  wrappedComponentRef: (ref: any) => any;
  onSubmit: (...args: any[]) => any;
  showCaptcha?: boolean;
  submitting?: boolean;
};
class PasswordForm extends React.PureComponent<Props> {
  captchaRef: any;
  formRef = React.createRef<FormInstance>();
  resetCaptcha = () => {
    this.captchaRef.reset();
  };

  render() {
    const { onSubmit, showCaptcha, submitting } = this.props;

    return (
      <Form
        ref={this.formRef}
        onFinish={() => {
          onSubmit(this.formRef, 'password');
        }}
      >
        <FormItem
          {...formItemLayout}
          name="username"
          rules={[
            {
              required: true,
              message: '请输入登录的手机号码/邮箱/账号',
            },
          ]}
        >
          <Input prefix={<UserOutlined />} placeholder="手机号码/邮箱/账号" autoFocus />
        </FormItem>
        <FormItem
          name="password"
          rules={[
            {
              required: true,
              message: '请输入密码',
            },
          ]}
        >
          <Password />
        </FormItem>
        {showCaptcha && (
          <FormItem name="position" rules={[{ required: true, message: '请向右滑动完成拼图' }]}>
            <CaptchaSlider ref={(ref) => (this.captchaRef = ref)} />
          </FormItem>
        )}
        <FormItem name="rememberMe" valuePropName="checked" className="form-check">
          <Checkbox>记住我</Checkbox>
        </FormItem>
        <FormItem>
          <a
            className="login-form-forgot"
            href={`${APP_URL}/sign/#!/forgetPassword`}
            target="_blank"
          >
            忘记密码？
          </a>
          <Button
            className="form-submit-button"
            type="primary"
            htmlType="submit"
            loading={submitting}
          >
            登录
          </Button>
        </FormItem>
      </Form>
    );
  }
}

export default PasswordForm;
